module.exports = __webpack_public_path__ + "img/Lock.eed03eb3.svg";